import { render } from "./ContactCard.vue?vue&type=template&id=1db7c0b4"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"

import "./ContactCard.vue?vue&type=style&index=0&id=1db7c0b4&lang=css"

import exportComponent from "E:\\Faks Projekti\\ssa_sajt\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__